/* Polyfill :before CSS usage for inputs in Firefox and Edge/IE */
interface elemDOM extends HTMLElement {
  checked: boolean
}

if (typeof window.navigator !== 'undefined' && window.navigator.userAgent.indexOf("Firefox") > -1 ||
  window.navigator.userAgent.indexOf("Edge") > -1 ||
  window.navigator.userAgent.indexOf("MSIE") > -1) {

  var localeSelector = document.getElementById('pv-nav-locales-menu-trigger') as elemDOM
  var accountSelector = document.getElementById('pv-nav-accounts-menu-trigger') as elemDOM
  var avSearch = document.getElementById('av-search-nav') as elemDOM
  if (localeSelector && accountSelector) {
    accountSelector.addEventListener('click', function () {
      if (accountSelector.checked) {
        localeSelector.checked = false
      }
    })

    localeSelector.addEventListener('click', function () {
      if (localeSelector.checked) {
        accountSelector.checked = false
      }
    })
  }

  if (avSearch) {
    avSearch.addEventListener('click', function () {
      if (localeSelector && localeSelector.checked) {
        localeSelector.checked = false
      }
      if (accountSelector && accountSelector.checked) {
        accountSelector.checked = false
      }
    })
  }
}